import type { Subcategory } from '../model'
import { getSubcategory } from './get-subcategory'

export function getCategoryMetadata({
  category,
  subcategories,
}: {
  category: string | null | undefined
  subcategories: Subcategory[]
}) {
  const subcategory = getSubcategory({ category, subcategories })

  if (!subcategory) {
    return null
  }

  return subcategory.metadata
}
